import React, {Fragment } from 'react';
import { 
    FormDataConsumer,
    TextInput ,
} from 'react-admin';
import { useForm } from 'react-final-form';
import TableCell from '@material-ui/core/TableCell';



const getValidate=(val) => {
    let dummy= null;

    if(!val || parseFloat(val) < 97.00 || parseFloat(val) > 99.4){
        dummy = (document.getElementById("tx_temp"))? document.getElementById("tx_temp").setAttribute("style", "color: red;"): null;
    }else{

    dummy = (document.getElementById("tx_temp"))?document.getElementById("tx_temp").removeAttribute("style"):null;
    }
    return val
}

const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();

    return (
        <Fragment>
             <TableCell >
                <TextInput 
                    id="tx_temp"
                    source="temperature" 
                    label=""
                    onChange ={getValidate(formData.temperature),
                        formData.temperature = getValidate(formData.temperature) 
                    }
                    {...rest}
                    />
             </TableCell>          
        </Fragment>
    );
};
const Temp = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default Temp